import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ConcessaoArquivoDTO } from 'app/model/dtos/mob/concessao-arquivo.dto';
import { ConcessaoArquivoService } from 'app/services/mob/concessao-arquivo.service';
import { ModalService, MODAL_DATA } from 'app/tools/modal/modal.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ArquivosConcessaoFormComponent } from 'app/view/concessao/shared/mob/arquivos-concessao-form/arquivos-concessao-form.component';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'button-salvar-arquivo-concessao',
  templateUrl: './button-salvar-arquivo-concessao.component.html',
  styleUrls: ['./button-salvar-arquivo-concessao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class ButtonSalvarArquivoConcessaoComponent implements OnInit {

  formGroup: FormGroup;
  cdConcessao: number;

  constructor(
    @Inject(forwardRef(() => MODAL_DATA)) private params,
    private _controlContainer: ControlContainer,
    private _concessaoArquivoService: ConcessaoArquivoService,
    private _dialogFactory: DialogFactory,
    private _modalService: ModalService<ArquivosConcessaoFormComponent>,
    private _router: Router
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

  ngAfterViewInit() {
    this.cdConcessao = this.params.cdConcessao;
  }

  async onSubmit() {
    if (!this.formGroup.valid)
      return this.formGroup.markAllAsTouched();

    try {
      let concessaoArquivoDTO: ConcessaoArquivoDTO = this.formGroup.value;
      concessaoArquivoDTO.cdConcessao = this.cdConcessao;
      concessaoArquivoDTO = await this._concessaoArquivoService.create(concessaoArquivoDTO);
      this._dialogFactory.snack('O arquivo foi salvo com sucesso.', 'OK', DialogFactory.SNACK_SUCCESS, { duration: 5000 });
      this.formGroup.disable();
      this._modalService.dismiss();
    }
    catch (error) {
      console.log(error);
      this._dialogFactory.snack(error.detail || error.message, 'OK', DialogFactory.SNACK_ERROR, { duration: 5000 });
    }
  }
}